export const notFoundEn = {
  title: '404',
  heading: 'Oops! This page seems to be missing from our menu.',
  description:
    "It looks like you've ordered something we don't serve. Let's get you back to our regular menu.",
  buttons: {
    home: 'Back to Homepage',
    menu: 'View Our Menu',
  },
};
